export enum Position {
  End = 'end',
  Start = 'start',
}
